import { createSelector } from '@reduxjs/toolkit'

import { PermissionRequirement } from '@/ducks/auth/auth.types'
import { AuthState } from '@/ducks/auth/slice/auth.slice'

export const selectAuth = (state: { auth: AuthState }) => state.auth

export const selectToken = createSelector(selectAuth, auth => {
  return auth.token
})
export const selectIsAuthed = createSelector(selectAuth, auth => !!auth.token)
export const selectAuthSource = createSelector(selectAuth, auth => auth.authSource)
export const selectLoginAs = createSelector(selectAuth, auth => auth.login_as)
export const selectPermissions = createSelector(selectAuth, auth =>
  auth.permissions || []
)
export const selectRolesLoaded = createSelector(selectAuth, auth => auth.rolesLoaded)
export const selectRolesError = createSelector(selectAuth, auth => auth.rolesError)
export const selectHasPermission = (requirement: PermissionRequirement) =>
  createSelector(selectPermissions, permissions =>
    permissions.some(
      permission =>
        permission.resource === requirement.resource &&
        permission.operation === requirement.operation
    )
  )
